import { render, staticRenderFns } from "./Agree.vue?vue&type=template&id=14a942d7&scoped=true"
import script from "./Agree.vue?vue&type=script&lang=js"
export * from "./Agree.vue?vue&type=script&lang=js"
import style0 from "./Agree.vue?vue&type=style&index=0&id=14a942d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a942d7",
  null
  
)

export default component.exports